




















































































































import ValidatableInputField    from "@/components/auth/ValidatableInputField.vue";
import AuthApi                  from "@/store/api/auth";
import { IUser }                from "@/store/models";
import { extend }               from "vee-validate/dist/vee-validate.full.esm";
import { Component, Prop, Vue } from "vue-property-decorator";

extend("checkUsername", {
      message : "User already exists",
      validate: (value: string) => {
          return async () => {
              const response = await AuthApi.getUsernameExists(value);

              return !response.data as boolean;
          };
      }
  });


  extend("checkEmail", {
      message : "Email already exists",
      validate: (value: string) => {
          return async () => {
              return !!value;
              // let response = await AuthApi.Instance.getEmailExists(value);
              //
              // resolve({
              //     valid: !response.data as boolean
              // });
          };
      }
  });

  @Component({
      name      : "AuthForm",
      components: {
          ValidatableInputField
      }
  })
  export default class AuthForm extends Vue {
      @Prop({
          default : false,
          type    : Boolean,
          required: false
      })
      public isRegister!: boolean;

      private username       = "";
      private password       = "";
      private passwordRepeat = "";
      private email          = "";
      private firstname      = "";
      private lastname       = "";
      private phone          = "";
      private postalCode     = "";
      private town           = "";
      private street         = "";
      private country        = "";

      submit(): void {
          if (this.isRegister) {

              const user: IUser = {
                  email    : this.email,
                  firstName: this.firstname,
                  lastName : this.lastname,
                  username : this.username ?? this.email,
                  contact  : {
                      country   : this.country,
                      locale    : 0,
                      phone     : this.phone,
                      postalCode: this.postalCode,
                      street    : this.street,
                      town      : this.town
                  },
                  password : this.password
              };

              AuthApi.registerUser(user).then(result => {
                  if (result.status == 201) {
                      this.$router.push({name: "Overview"});
                  } else {
                      this.$notify.error({
                          message: result.status.toString()
                      });
                      this.$notify.error({
                          message: result.statusText
                      });
                      this.$notify.error({
                          message: result.data
                      });
                  }
              });
          }
      }


  }
